import createStore from 'app/create-store';
import createRoutes from 'app/routes';
import store from 'app/store';
import historyProvider from 'app/history';
import { render } from 'react-dom';
import React from 'react';
import { Provider } from 'react-redux';

export default function renderAppIntoElementWithHistory(element, history) {
  const newStore = createStore();
  // eslint-disable-next-line no-underscore-dangle
  window._store = newStore;
  store.set(newStore);
  historyProvider.set(history);

  render(<Provider store={newStore}>{createRoutes(history)}</Provider>, element);
}
